import { FormControlLabel, Switch, Typography } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import swal from "sweetalert";
import MainLayout from "../../components/MainLayout";
import axiosInstance from "../../utils/axiosInstance";

export default function Settings() {
  const [isChatBotEnabled, setIsChatBotEnabled] = useState();

  const handleToggleChatBot = async () => {
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}/enable-chat-bot`,
      );

      if (response.status === 200) {
        setIsChatBotEnabled(response.data);
        swal(
          `Successful ${response.data ? "enabled" : "disabled"} chatbot feature`,
          { icon: "success" },
        );
      }
    } catch (error) {}
  };

  const fetchChatBotStatus = useCallback(async () => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}/chat-bot-status`,
      );

      if (response.status === 200) {
        setIsChatBotEnabled(response.data);
      }
    } catch (error) {}
  }, []);

  useEffect(() => {
    fetchChatBotStatus();
  }, [fetchChatBotStatus]);

  return (
    <MainLayout>
      <Typography variant="h6">Settings</Typography>
      <FormControlLabel
        control={
          <Switch
            checked={isChatBotEnabled}
            onChange={handleToggleChatBot}
            color="primary"
          />
        }
        label="Enable Chat Bot"
      />
    </MainLayout>
  );
}
